import { useTranslations } from "next-intl";

import RelayPointCard from "./RelayPointCard";
import CustomLoader from "../CustomLoader";

const RelayPointsList = ({
  relayPointsList,
  selectedRelayPoint,
  setSelectedRelayPoint,
  loadingRelayPoints,
  initializing = false,
  submitButton = false,
  onSubmit = null,
  hidden = false,
}) => {
  const t = useTranslations("addresses");

  return (
    <div className={`d-flex flex-column gap-2 ${hidden ? "d-none" : ""}`}>
      {loadingRelayPoints && <CustomLoader style={{ width: "120px" }} />}

      {!relayPointsList?.length && !initializing && !loadingRelayPoints && (
        <div className="text-center my-2">{t("no_relay_point_found")}</div>
      )}

      {!loadingRelayPoints &&
        relayPointsList?.map((relayPoint) => (
          <RelayPointCard
            key={relayPoint.pickup_id}
            relayPoint={relayPoint}
            selectedRelayPoint={selectedRelayPoint}
            setSelectedRelayPoint={setSelectedRelayPoint}
            submitButton={submitButton}
            onSubmit={onSubmit}
          />
        ))}
    </div>
  );
};

export default RelayPointsList;
